import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/employee-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/employee-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/employee-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/employee-profiles/${data.employee_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/employee-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getdivision = (Options = {}) => {
  return httpClient
    .get('/api/employee-profiles/divisions', Option)
    .then(response => Promise.resolve(response.data))
}

export const getdepartment = (Options = {}) => {
  return httpClient
    .get('/api/employee-profiles/departments', Option)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  getdivision,
  getdepartment
}
